import { ActionIcon, type ActionIconProps, Button, type ButtonProps } from '@mantine/core';
import type { MouseEventHandler } from 'react';
import { useGuardedModalClose } from './GuardedModalCloseContext';

type GuardedModalCancelButtonProps = ButtonProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

type GuardedModalCloseActionIconProps = ActionIconProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const GuardedModalCancelButton = ({ onClick, ...props }: GuardedModalCancelButtonProps) => {
  const requestClose = useGuardedModalClose();

  return (
    <Button
      {...props}
      onClick={(event) => {
        onClick?.(event);
        requestClose();
      }}
    />
  );
};

export const GuardedModalCloseActionIcon = ({ onClick, ...props }: GuardedModalCloseActionIconProps) => {
  const requestClose = useGuardedModalClose();

  return (
    <ActionIcon
      {...props}
      onClick={(event) => {
        onClick?.(event);
        requestClose();
      }}
    />
  );
};
